import { useState, useEffect } from 'react'
import { Row, Col, Input } from 'antd'
import useTranslation from '@/hooks/useTranslation'

import Label from '@/components/shared-components/form/Label'
import InputNormal from '@/components/shared-components/form/Input'
import DatePickerInput from '@/components/shared-components/form/DatePicker'
import SelectCountries from '@/components/shared-components/form/SelectCountries'
import SelectCountryCodes from '@/components/shared-components/form/SelectCountryCodes'
import RadioGroup from '@/components/shared-components/form/RadioGroup'

import UpdatePassword from '@/components/shared-components/modals/UpdatePassword'
import UpdateEmail from '@/features/profile/components/UpdateEmail'

const PersonalInformation = (props) => {
  const { t } = useTranslation()

  const { formValues, setFormValues, errors } = props

  const [updateEmailOpen, setUpdateEmailOpen] = useState(false)
  const [updatePasswordOpen, setUpdatePasswordOpen] = useState(false)
  const [inItaly, setInItaly] = useState(true)

  useEffect(() => {
    formValues.birth_place !== 'Italia' ? setInItaly(false) : setInItaly(true)
  }, [formValues.birth_place])

  return (
    <>
      <Row className='form-type_5' gutter={[16, 16]}>
        <Col xs={24} sm={12}>
          <InputNormal
            disabled
            label={t('First Name')}
            name='name'
            value={formValues.name}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                name: e.target.value,
              })
            }
            error={errors?.name}
          />
        </Col>
        <Col xs={24} sm={12}>
          <InputNormal
            disabled
            label={t('Last Name')}
            name='lname'
            value={formValues.lname}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                lname: e.target.value,
              })
            }
            error={errors?.lname}
          />
        </Col>
        <Col xs={24} sm={12}>
          <div className='input'>
            <Label
              label='form.email.label'
              buttonClick={() => setUpdateEmailOpen(true)}
            />
            <InputNormal disabled value={formValues.email} />
          </div>
        </Col>

        <Col xs={24} sm={12}>
          <div>
            <Label label='form.mobile.label' error={errors.mobile_number} />
            <Row gutter={8}>
              <Col xs={10} lg={8}>
                <SelectCountryCodes
                  {...{
                    value: formValues.mobile_number_code,
                    setValue: (value) => {
                      setFormValues({
                        ...formValues,
                        mobile_number_code: `+${value}`,
                      })
                    },
                  }}
                />
              </Col>
              <Col xs={14} lg={16}>
                <InputNormal
                  name='mobile_number'
                  value={formValues.mobile_number}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      mobile_number: e.target.value,
                    })
                  }
                />
              </Col>
            </Row>
          </div>
        </Col>

        <Col xs={24} sm={12}>
          <RadioGroup
            {...{
              name: 'gender',
              label: 'Gender',
              value: formValues.gender,
              setValue: (value) => {
                setFormValues({
                  ...formValues,
                  gender: value,
                })
              },
              error: errors?.gender,
              options: [
                { label: 'Male', value: 'M' },
                { label: 'Female', value: 'F' },
              ],
            }}
          />
        </Col>

        <Col xs={24} sm={12}>
          <SelectCountries
            {...{
              name: 'nationality',
              label: 'Nationality',
              placeholder: 'Select Nationality',
              value: formValues.nationality,
              setValue: (val) => {
                setFormValues({
                  ...formValues,
                  nationality: val,
                })
              },
              error: errors.nationality,
            }}
          />
        </Col>

        <Col xs={24} sm={12}>
          <div>
            <Label label='Birth Date' error={errors.birth_date} />
            <DatePickerInput
              validation='lt'
              dateValue={formValues.birth_date}
              setDateValue={(dateString) =>
                setFormValues({ ...formValues, birth_date: dateString })
              }
            />
          </div>
        </Col>

        <Col xs={24} sm={12}>
          <div className='input'>
            <Label
              label='form.password.label'
              buttonClick={() => setUpdatePasswordOpen(true)}
            />
            <Input value='*************' />
          </div>
        </Col>

        <Col span={24}>
          <div>
            <Label label='Birth Place' error={errors.birth_place} />
            <Row
              className='bg-white border border-[#DDD] rounded-xl p-16'
              gutter={[16, 16]}
            >
              <Col xs={24} sm={12}>
                <RadioGroup
                  {...{
                    name: 'birth_place',
                    label: 'Country',
                    value: inItaly,
                    setValue: (value) => {
                      if (value === true) {
                        setFormValues({
                          ...formValues,
                          birth_place: 'Italia',
                          country_code: 'IT',
                        })
                      }
                      setInItaly(value)
                    },
                    options: [
                      { label: 'Italy', value: true },
                      { label: 'un altro paese', value: false },
                    ],
                  }}
                />
              </Col>
              {!inItaly && (
                <Col xs={24} sm={12}>
                  <SelectCountries
                    {...{
                      name: 'birth_place',
                      label: 'Birth Country',
                      placeholder: 'Select Birth Country',
                      formValues,
                      setFormValues,
                      value: formValues.birth_place,
                      setValue: (val) => {
                        setFormValues({
                          ...formValues,
                          birth_place: val,
                        })
                      },
                      error: errors.birth_place,
                    }}
                  />
                </Col>
              )}
            </Row>
          </div>
        </Col>
      </Row>

      <UpdateEmail open={updateEmailOpen} setOpen={setUpdateEmailOpen} />
      <UpdatePassword
        open={updatePasswordOpen}
        setOpen={setUpdatePasswordOpen}
      />
    </>
  )
}

export default PersonalInformation
